Librarian.HTMLInputWindow = new Class({
    Extends: Librarian.Window,

    options: {
        id: "HTMLInputWindow",
        resizable: true,
        title: '',
        minimizable: false,
        height: 350,
        width: 475,
        initialValue: '',
        padding: {
            top: 10,
            right: 0,
            bottom: 0,
            left: 0
        }
    },

    onSubmit: null,
    onCancel: null,

    initialize: function (options) {
        this.setOptions(options);

        this.onSubmit = options.onSubmit;
        this.onCancel = options.onCancel;

        this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/htmlinput.html";
        this.options.toolbar = "fontfamily fontsize | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify outdent indent | numlist bullist | removeformat link insertimage charmap";

        this.parent(this.options);
    },

    onClose: function () {
        var itemEl = this.getElement("inputArea");
        if (itemEl) {
            tinyMCE.execCommand("mceRemoveEditor", false, itemEl.id);
            itemEl.editor = null;
            itemEl.destroy();
        }

        this.parent();
    },

    onResize: function() {
        this.resizeInputMessageBox();
    },

    resizeInputMessageBox: function() {
        var contentEl = this.getElement("content");
        var contentPadding = contentEl.getStyle("padding-top").toInt() + contentEl.getStyle("padding-bottom").toInt();
        var contentHeight = contentEl.getHeight(true) - contentPadding;
        
        var inputAreaEl = this.getElement("inputAreaWrapper");
        var inputAreaHeight = contentHeight;

        var siblings = inputAreaEl.getSiblings();
        var siblingsHeight = Array.sum(siblings.getHeight(true));

        inputAreaHeight -= siblingsHeight;
        inputAreaEl.setStyle("height",inputAreaHeight);
    },

    onWindowLoaded: function () {
        this.setupElements();

        var inputEl = this.getElement("inputArea");
        if (inputEl) {
            Librarian.Utils.setElementValue(inputEl, this.options.initialValue || '');

            var options = Librarian.Utils.getTinyMCEOptions({
                plugins: "advlist lists code charmap",
                toolbar: Librarian.event.disableEditorToolbar ? false : (this.options.toolbar + (Librarian.editor.showCodeButton ? " | code" : '')),
                selector: '#' + inputEl.id,
                width: "100%",
                height: "100%",
                setup: function (editor) {
                    inputEl.editor = editor;
                    Librarian.Utils.addTinyMCEButton(editor, "insertimage");
                    editor.on('BeforeSetContent', function (ed) {
                        // Remove all paragraphs and replace with BR
                        ed.content = ed.content.replace(/<p[^>]*>/g, '');
                        ed.content = ed.content.replace(/<\/p\s*>/g, '<br />');
                    });
                }.bind(this)
            });

            tinyMCE.init(options);
        }

        var okButton = this.getElement("okButton");
        if (okButton) {
            okButton.addOnClick(function () {
                if (inputEl && typeof this.onSubmit == "function") {
                    var message = tinyMCE.get(inputEl.id).getContent() || ' ';

                    // Remove extra line breaks in markup
                    message = message.replaceAll('\n', '');

                    this.onSubmit(message);
                }
                this.close();
            }.bind(this));
        }

        var cancelButton = this.getElement("cancelButton");
        if (cancelButton) {
            cancelButton.addOnClick(function () {
                if (this.onCancel == "function")
                    this.onCancel();

                this.close();
            }.bind(this));
        }

        if (this.options.resizable) {
            this.onResize();
        }
    }
});